// Guarded Web Storage. localStorage can be missing or throw (private windows,
// blocked site data, Node's experimental global on some runners); every read
// and write goes through these helpers so the app still renders without it.

function store(): Storage | null {
  try {
    const s = globalThis.localStorage;
    if (!s || typeof s.getItem !== 'function') return null;
    return s;
  } catch {
    return null;
  }
}

export function readStore(key: string): string | null {
  try {
    return store()?.getItem(key) ?? null;
  } catch {
    return null;
  }
}

export function writeStore(key: string, value: string | null): void {
  try {
    const s = store();
    if (!s) return;
    if (value == null) s.removeItem(key);
    else s.setItem(key, value);
  } catch {
    /* storage unavailable — the in-memory copy still works for this page */
  }
}

export function readJson<T>(key: string): T | null {
  const raw = readStore(key);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}
